/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import CustomCard from "../../../components/CustomCard/CustomCard";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/Reducer";
import { getNegotiationActions } from "../../../redux/Action/Action";

interface CardData {
  id: string;
  title: string;
  description: string;
  relatedPhase: string;
  flag: string;
  actionType: any;
  isTrending: any;
  isMostSelected: any;
  avgRating: any;
  status: boolean;
  preselected: boolean;
  inputText: string;
  isCardSelected?: boolean;
}
interface PreparationPageProps {
  onCardSelect: (selectedActionTilesMap: CardData[]) => void;
  setSelectedActionTilesMap: any;
  selectedActionTilesMap: CardData[];
  ParentDependecyMap: Record<string, string>;
  deselectedCardIds: Set<string>;
  setDeselectedCardIds: React.Dispatch<React.SetStateAction<Set<string>>>;
}
const PreparationPage = ({
  onCardSelect,
  selectedActionTilesMap,
  setSelectedActionTilesMap,
  ParentDependecyMap,
  deselectedCardIds,
  setDeselectedCardIds,
}: PreparationPageProps) => {
  const [cardData, setCardData] = useState<CardData[]>([]);
  const [inputTexts, setInputTexts] = useState<{ [cardId: string]: string }>(
    {}
  );
  const dispatch = useDispatch();
  const sampleCardss = useSelector(
    (state: RootState) => state.negotiationActions.negotiationActions
  );
  const powerPositionData = useSelector(
    (state: RootState) => state.powerPosition.powerPosition
  );
  const ReduxSelectedCards =
    useSelector(
      (state: RootState) => state?.selectedActionTiles?.SelectedActionTilesData
    ) || {};
  const negotiationRoundSelectedCards = Object.entries(ReduxSelectedCards)
    .filter(([key]) => key.startsWith("Round"))
    .flatMap(([, cards]) => cards);
  useEffect(() => {
    dispatch(getNegotiationActions());
  }, []);

  useEffect(() => {
    if (cardData.length === 0) return;
    negotiationRoundSelectedCards.forEach((negotiationCard: any) => {
      const dependentCardId = ParentDependecyMap[negotiationCard.id];
      if (dependentCardId) {
        const isDependentCardSelected = selectedActionTilesMap.some(
          (c: CardData) => c.id === dependentCardId
        );
        const isDependentCardDeselected =
          deselectedCardIds.has(dependentCardId);
        // Select dependent card if it's not selected and not deselected
        if (!isDependentCardSelected && !isDependentCardDeselected) {
          const dependentCard = cardData.find(
            (card) => card.id === dependentCardId
          );
          if (dependentCard) {
            const updatedSelectedCards = [
              ...selectedActionTilesMap,
              dependentCard,
            ];
            setSelectedActionTilesMap(updatedSelectedCards);
            onCardSelect(updatedSelectedCards);
          }
        }
      }
    });
  }, [negotiationRoundSelectedCards, cardData, deselectedCardIds]);

  useEffect(() => {
    if (sampleCardss.length > 0) {
      const PreparationStepCards = sampleCardss.filter((item: any) => {
        const isPreparation =
          item.relatedPhase === "Preparation" && item.status === true;
        const isDependant =
          powerPositionData === "Dependent" && item.title === "Use the phone";
        const isMighty =
          powerPositionData === "Superior" &&
          item.title === "Empower your portfolio";
        const isWeak =
          powerPositionData === "Inferior" &&
          (item.title === "Use the phone" ||
            item.title === "Invite two competitors one after another");
        return isPreparation && !(isDependant || isMighty || isWeak);
      });
      const formattedCards: CardData[] = PreparationStepCards.map(
        (item: any) => ({
          ...item,
          inputText: "",
        })
      );
      setCardData(formattedCards);
      const initialInputTexts: { [cardId: string]: string } = {};
      formattedCards.forEach((card) => {
        initialInputTexts[card.id] = "";
      });
      setInputTexts(initialInputTexts);
    }
  }, [sampleCardss]);

  /**
   * Effect to preselect cards based on the `preselected` property.
   * If no cards are selected, it will select cards that have `preselected` set to true.
   * This ensures that the initial state of the component has some cards selected
   */

  useEffect(() => {
    if (cardData.length === 0) return;
    const hasSavedSelections = selectedActionTilesMap?.length > 0;
    if (!hasSavedSelections) {
      const preselectedCards = cardData.filter((card) => card.preselected);
      if (preselectedCards.length > 0) {
        setSelectedActionTilesMap(preselectedCards);
        onCardSelect(preselectedCards);
      }
    }
  }, [cardData]);

  /**
   *
   * @param cardId - The ID of the card that was clicked.
   * This function handles the click event on a card.
   */

  const handleCardClick = (cardId: string) => {
    const dependentCardId = ParentDependecyMap[cardId];
    const isSelected = selectedActionTilesMap.some(
      (card) => card.id === cardId
    );
    let newSelectedCards = [...selectedActionTilesMap];
    if (isSelected) {
      newSelectedCards = newSelectedCards.filter(
        (card) => card.id !== cardId && card.id !== dependentCardId
      );
      setDeselectedCardIds(
        (prev) => new Set([...prev, cardId, dependentCardId])
      );
    } else {
      const card = cardData.find((c) => c.id === cardId);
      const dependentCard = cardData.find((c) => c.id === dependentCardId);
      if (card)
        newSelectedCards.push({ ...card, inputText: inputTexts[cardId] || "" });
      if (dependentCard)
        newSelectedCards.push({
          ...dependentCard,
          inputText: inputTexts[dependentCardId] || "",
        });
      // Clear deselectedCardIds for these cards
      setDeselectedCardIds((prev) => {
        const updated = new Set(prev);
        updated.delete(cardId);
        updated.delete(dependentCardId);
        return updated;
      });
    }
    setSelectedActionTilesMap(newSelectedCards);
    onCardSelect(newSelectedCards);
  };

  /**
   *  Handles the input change for a specific card.
   * This function updates the input text for the card in the selectedActionTilesMap state.
   * @param cardId - The ID of the card whose input text is being changed.
   * @param value
   */
  const handleInputChange = (cardId: string, value: string) => {
    const updatedCards = selectedActionTilesMap.map((card) =>
      card.id === cardId ? { ...card, inputText: value } : card
    );
    setSelectedActionTilesMap(updatedCards);
    onCardSelect(updatedCards);
  };
  return (
    <div>
      <div className="negoRound-responsive-grid">
        {cardData.map((card) => (
          <div
            key={card.id}
            onClick={() => handleCardClick(card.id)}
            className="displayCards"
          >
            <CustomCard
              id={card.id}
              title={card.title}
              description={card.description}
              flag={card.flag}
              actionType={card.actionType}
              isTrending={card.isTrending}
              isMostSelected={card.isMostSelected}
              avgRating={card.avgRating}
              inputText={
                selectedActionTilesMap.find((obj) => obj.id === card.id)
                  ?.inputText ?? ""
              }
              onInputChange={(value) => handleInputChange(card.id, value)}
              isCardSelected={selectedActionTilesMap.some(
                (obj) => obj.id === card.id
              )}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PreparationPage;
